import { map } from 'lodash'
import { CreditNoteDecorator } from 'decorators'
import { http } from 'utils'
import accounting from 'accounting'

import { SET_CREDIT_NOTES, ADD_CREDIT_NOTE, SET_ACCOUNT_CREDIT } from 'vx/mutations'

// Credit note state.
const state = {
  creditNotes: [],
  accountCredit: null
}

// Credit note state getters.
const getters = {
  creditNotesDecorated: state => map(state.creditNotes, creditNote => new CreditNoteDecorator(creditNote)),
  accountCredit: state => accounting.formatMoney(state.accountCredit)
}

// Credit note actions.
const actions = {
  /**
   * Get account credit for a given user.
   */
  getAccountCredit ({ commit }, user) {
    return http.get(`users/${user}/account-credit`).then(response => {
      commit(SET_ACCOUNT_CREDIT, response.data.amount)
    })
  },

  /**
   * Get credit notes for a given user.
   */
  getCreditNotes ({ commit }, user) {
    return http.get(`users/${user}/credit-notes`).then(response => {
      commit(SET_CREDIT_NOTES, response.data)
    })
  },

  /**
   * Save a credit note against a given user.
   */
  saveCreditNote ({ commit }, { user, payload }) {
    return http.post(`users/${user}/credit-notes`, payload).then(response => {
      commit(ADD_CREDIT_NOTE, response.data)
    })
  }
}

// Credit note state mutations.
const mutations = {
  /**
   * Set the credit notes.
   */
  [SET_CREDIT_NOTES] (state, creditNotes) {
    state.creditNotes = creditNotes
  },

  /**
   * Add a credit note.
   */
  [ADD_CREDIT_NOTE] (state, creditNote) {
    state.creditNotes.unshift(creditNote)
  },

  /**
   * Set the users account credit.
   */
  [SET_ACCOUNT_CREDIT] (state, accountCredit) {
    state.accountCredit = accountCredit
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user/credit-note.js